import React, {useState, useEffect, useContext} from 'react'
import { useNavigate } from 'react-router-dom';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';
import userService from '../services/UserService';

const AuthContext = React.createContext()

export function useAuth(){
    return useContext(AuthContext);
}

export function AuthProvider(props){
    const [authUser, setAuthUser] = useState(null)
    const [notifications, setNotifications] = useState(null)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [loading, setLoading] = useState(true); 
    const navigate = useNavigate(); 
    const checkAuthentication = async () => {
        try {
            setLoading(true);
            const response = await userService.getCurrentUser();
            setAuthUser(response.userDTO);
            setNotifications(response.notifications)
            setIsLoggedIn(true);
            if(response.userDTO.isNewlyCreated && response.userDTO.linked){
                navigate('/success');
            }
        } catch (error) {
            setIsLoggedIn(false);
            setAuthUser(null);
        } finally {
            setLoading(false);  
        }
    };
    useEffect(() => {
        checkAuthentication();
    }, []);
    
    if (loading) {
        return <CircleSpinnerOverlay loading={loading} overlayColor="rgba(0, 0, 0, 0.8)" color='#1b1b1bff' />;  
    }

    const value = {
        authUser,
        setAuthUser,
        notifications,
        setNotifications,
        isLoggedIn,
        setIsLoggedIn,
        checkAuthentication,
        loading,
        setLoading,
    }

    return (
        <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
    )
}